import { api } from "@/config/api-fetch";
import { OPTIONS } from "@/utils/constants";
import { useQuery } from "@tanstack/react-query";

export type KnowledgeBase = {
    id: string;
    title: string;
    link: string;
    edit_link?: string;
    post_id?: number;
    modified: string | Date;
    chunks: { id: string; index: number; text: string }[];
};

export enum KbType {
    wp = "wp",
    pdf = "pdf",
    url = "url",
    txt = "txt",
}

export function useKnowledgeBase(type: KbType, post_type = "post", page = 1) {
    const limit = OPTIONS.PAGINATION_LIMIT;
    const offset = (page - 1) * limit;

    let url = `/knowledge-base?type=${type}`;

    if (type === KbType.wp) {
        url += `&post_type=${post_type}&offset=${offset}&limit=${limit}`;
    }

    const query = useQuery({
        queryKey: ["knowledge-base", type, post_type, page],
        queryFn: async () => api.get<KnowledgeBase[]>(url),
    });

    return query;
}

type KnowledgeBaseStat = {
    type: KbType;
    total: number;
};

export function useKnowledgeBaseStats() {
    const query = useQuery({
        queryKey: ["knowledge-base-stats"],
        queryFn: async () => api.get<KnowledgeBaseStat[]>(`/knowledge-base/stats`),
    });

    return query;
}